<template>
  <div class="page">
    <m-box class="has-el-form" v-loading="isLoading">
      <el-form inline>
        <el-form-item label="渠道ID">
          <el-select v-model="formData.channel_id" :size="formSize" clearable >
            <el-option v-for="channel in channels" :value="channel.channel_id" :key="channel.channel_id" :label="`${channel.channel_id}（${channel.channel_name}）`"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号ID">
          <el-input v-model="formData.user_id" :size="formSize" placeholder="账号ID" class="input-with-select">
            <el-select :size="formSize" v-model="formData.user_type" style="width: 120px;" slot="prepend">
              <el-option v-for="item in userTypes" :value="item.value" :key="item.value" :label="item.label"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="查询日期">
          <el-date-picker
            v-model="formData.begin_time"
            value-format="yyyy-MM-dd HH:mm:ss"
            :size="formSize"
            placeholder="开始日期">
          </el-date-picker> -
          <el-date-picker
            v-model="formData.end_time"
            @change="getEndTime"
            value-format="yyyy-MM-dd"
            :size="formSize"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :size="formSize" @click="handleQuery">查询</el-button>
          <el-button :size="formSize" @click="handleRest">重置</el-button>
        </el-form-item>
      </el-form>
    </m-box>

    <m-box title="查询结果">
      <el-table
        :data="tableData"
        border
        stripe
        >
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column label="当前绑定的账号" prop="order_id" min-width="160">
          <template slot-scope="scope" v-if="scope.row.avatar || scope.row.nick_name">
            <img :src="scope.row.avatar" width="30" height="30" style="margin-right:10px; vertical-align:middle"  />
            <span>昵称: {{scope.row.nick_name}}</span>
            <span v-if="!!bindType(scope.row)">({{bindType(scope.row)}})</span>
          </template>
        </el-table-column>
        <el-table-column label="会员内容观看时间" prop="date"></el-table-column>
      </el-table>
      <el-pagination
        @current-change="handlePageChange"
        :current-page="formData.page_num"
        :page-size="formData.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </m-box>

  </div>
</template>
<script>
import channelApi from '../../api/channel';

export default {
  data () {
    return {
      formSize: 'small',
      formData: {
        user_type: 100,
        channel_id: '',
        user_id: '',
        begin_time: '',
        end_time: '',
        page_size:10,
        page_num:1,
      },
      total: 0,
      oldFormData: null,
      isLoading: false,
      list: [],
      userTypes: [
        { label: 'QQ', value: 1 },
        { label: '微信', value: 99 },
        { label: '手机号', value: 100 },
      ],
    }
  },
  computed: {
    channels () {
      return this.$store.state.user.channelInfo || []
    },
    tableData() {
      const start = (this.formData.page_num - 1) * this.formData.page_size;
      const end = start + this.formData.page_size;
      return this.list.slice(start, end);
    },
  },
  watch: {
    channels() {
      this.formData.channel_id = this.channels[0].channel_id;
    },
  },
  methods: {
    async handleQuery () {
      if (!this.formData.channel_id) return this.$message.warning('渠道ID不能为空');
      if (!this.formData.user_id) return this.$message.warning('账号ID不能为空');
      this.isLoading = true;
      try {
        this.formData.begin_time = this.formData.begin_time || '';
        this.formData.end_time = this.formData.end_time || '';
        const res = await channelApi.vipUsageRecords.getViewDate(this.formData);
        if (res.ret === 0 && res.data) {
          const arr = {
            ...res.data,
            phone: res.data.user_type === 100 ? res.data.user_id : '',
          };
          delete arr.flow;
          res.data.flow = res.data.flow.map(item => ({
            ...arr,
            ...item
          }));
          this.total = res.data.total;
          this.list = res.data.flow;
          this.handlePageChange(1);
        }
        this.isLoading = false;
      } catch(err) {
        this.isLoading = false;
        this.list = [];
        this.$message.error(err.message);
      }
    },
    getEndTime(value) {
      this.formData.end_time = `${value} 23:59:59`;
    },
    handlePageChange(page) {
      this.formData.page_num = page;
    },
    handleRest () {
      this.formData = JSON.parse(this.oldFormData)
    },
    bindType(row) {
      const type = this.userTypes.find(item => item.value === row.source_type);
      return type ? type.label : '';
    },
  },
  created () {
    this.oldFormData = JSON.stringify(this.formData)
    if (this.channels.length > 0) {
      this.formData.channel_id = this.channels[0].channel_id;
    }
  }
}
</script>

<style>
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
</style>
